import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { apis } from "../../api/apiUrl"


export const fetchUnitEnquiresTabData = createAsyncThunk(
    "fetchUnitEnquiresTabData",
    async (path) => {
        const response = await fetch(`${apis.umbraco_delivery_api}/${path}`,{
           
        })
        const data = await response.json()
        return data
    }
)

// Create a slice
const unitEnquiresTabSlice = createSlice({
    name: "unitEnquiresTab",
    initialState: {
        isLoading: false,
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(fetchUnitEnquiresTabData.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(fetchUnitEnquiresTabData.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        })
        builder.addCase(fetchUnitEnquiresTabData.rejected, (state,action) => {
            console.log("Error",action.payload)
            state.isLoading = false
        })

    }
})

export default unitEnquiresTabSlice.reducer